"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InputCustomEvent {
    constructor(context, key, data, metricValue, 
    // Currently custom events are not sampled, but this is here to make the handling
    // code more uniform.
    samplingRatio = 1) {
        this.context = context;
        this.key = key;
        this.data = data;
        this.metricValue = metricValue;
        this.samplingRatio = samplingRatio;
        this.kind = 'custom';
        this.creationDate = Date.now();
        this.context = context;
    }
}
exports.default = InputCustomEvent;
//# sourceMappingURL=InputCustomEvent.js.map